import React, { useEffect, useState } from 'react'
import { Box, Text } from "grommet"
import AgDataTable from '../../common/AgDataTable'
import Spinner from '../../common/Spinner'
import { HealthServiceDataViewStatus } from './HealthStatusService'

import { useMarket } from '../../../utils/market'
import { deepClone } from '../../../utils/clone'

const HealthStatusServiceStager = ({ data, nodeName }) => {

    const marketLookup = useMarket()

    const tab_col = [
        {
            field: "id",
            headerName: "ID",
            minWidth: 150,
            suppressSizeToFit: true,
            checkboxSelection: true
        },
        {
            field: "primary",
            headerName: "Type",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "marketName",
            headerName: "Market",
            minWidth: 200,
            suppressSizeToFit: true,
        },
        {
            field: "reason",
            headerName: "Reason",
            minWidth: 200,

        },
        {
            field: "status",
            headerName: "Status",
            cellStyle: function (params) {
                if (params.value === 'UP_SENDING_DISABLED') {
                    return { color: 'white', backgroundColor: '#A6A6A6' };
                }
                else if (params.value !== 'UP') {
                    return { color: 'white', backgroundColor: '#B4130B' };
                } else {
                    return { color: 'black', backgroundColor: 'white' };
                }
            },
            minWidth: 200,
        },
    ]

    const [tab_data, settab_data] = useState([])
    useEffect(() => {
        let tab_data_temp = []
        if (marketLookup) {
            tab_data_temp = Object.keys(data).sort((a, b) => (data[a].primary === "Primary") ? 1 : -1).sort((a, b) => (data[a].status === 'UP') ? 1 : -1).reduce((rowData, rowId) => {

                const row = deepClone(data[rowId])

                if (!row.markets || row.markets.length === 0) {
                    row.markets = [0]
                }

                for (let marketName of row.markets) {
                    marketName = marketName ? marketName.replace("TT_MARKET_ID_", "") : "-"

                    rowData.push({
                        'uniqueId': row.id + "__" + marketName,
                        'id': row.id,
                        'marketName': marketName,
                        'reason': row.reason,
                        'status': row.status,
                        'primary': row.primary ? "Primary" : "Secondary"
                    })
                }
                return rowData
            }, [])
            settab_data(tab_data_temp)
        }
    }, [data, marketLookup])

    return (
        <Box border="top" margin={{ top: "small", left: "xsmall", right: "xsmall" }} fill="horizontal">
            <Box direction="row">
                <Text margin={{ top: "8px", bottom: "8px" }} size="small" color="dark-3" weight="bold"> Accounts/Markets </Text>
                <HealthServiceDataViewStatus tab_data={tab_data.map(function (item) { return item["status"] })} />
            </Box>

            {!marketLookup
                ? <Spinner />
                :
                <AgDataTable
                    tab_col={tab_col}
                    tab_data={tab_data}
                    tableName="HealthStatusServiceStager"
                    defaultSubTab="Account"
                    countTitle="Accounts"
                    nodeName={nodeName}
                    tableHeight={700}
                />
            }
        </Box>
    )
}

export default HealthStatusServiceStager
